<template>
  <div class="follow-product-button-component" style="display: inline-block;">
    
    <button v-show="!loadingStatus && !followedProductExists" @click="saveFollowedProduct" type="button" class="btn btn-primary" style="width: 195px;">
      Lisää omalle listalle
      
      <span style="margin-left: 10px" data-toggle="tooltip" data-placement="bottom"
          title="Lisää tuote omalle listalle, josta voit seurata kuvailun tilaa ja sen valmistumista tekemättä erillistä kiirehtimispyyntöä.">
          <i class="fa fa-question-circle fa-lg" aria-hidden="true"></i>
      </span>
    </button>

    <button v-show="!loadingStatus && followedProductExists" @click="deleteFollowedProduct" type="button" class="btn btn-grey" style="width: 195px;">
      Poista omalta listalta

      <span style="margin-left: 10px" data-toggle="tooltip" data-placement="bottom"
          title="Lisää tuote omalle listalle, josta voit seurata kuvailun tilaa ja sen valmistumista tekemättä erillistä kiirehtimispyyntöä.">
          <i class="fa fa-question-circle fa-lg" aria-hidden="true"></i>
      </span>
    </button>

    <button v-show="loadingStatus == 'loading'" disabled type="button" class="btn btn-default" style="width: 195px; height: 34px">
      <i class="fa fa-spinner fa-spin fa-lg fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </button>

    <button v-show="loadingStatus == 'success'" disabled type="button" class="btn btn-default" style="width: 195px; height: 34px">
      <i class="fa fa-check fa-lg text-success"></i>
      <span class="sr-only">Ok</span>
    </button>

    <button v-show="loadingStatus == 'error'" disabled type="button" class="btn btn-default" style="width: 195px; height: 34px">
      <i class="fa fa-close fa-lg text-danger"></i>
      <span class="sr-only">Error</span>
    </button>

  </div>
 </template>

<script>

import { EventBus } from '@/event_bus.js';

export default {
    
  props: {
    productId: String,
  },

  data() {
    return {
      followedProductId: null,
      loadingStatus: null,
    }
  },

  computed: {
    followedProductExists() {
      return this.followedProductId ? true : false
    },
  },

  created() {
    // We have multiple FollowProductButton components in the same page so we need to sync all when one of them is clicked
    EventBus.$on('refresh-followed-product', this.getFollowedProduct);
  },

  mounted() {
    this.loadingStatus = "loading" // show loading spinner while getting the followed product
    this.getFollowedProduct()

    // initialize bootstrap tooltip
    $('.follow-product-button-component [data-toggle="tooltip"]').tooltip();
   },

  beforeDestroy() {
    EventBus.$off('refresh-followed-product', this.getFollowedProduct);
  },

  methods: {

    getFollowedProduct() {
      if (!this.productId) {
        this.loadingStatus = null; // just in case
        return
      } 

      const config = {
        url: `/luettelointi/omalista/search?product_id=${this.productId}`,
        method: 'get',
      }

      axios(config)
      .then((response) => {
        if (response.data && response.data.product) {
          this.followedProductId = response.data.product.id
        } else {
          this.followedProductId = null
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        this.loadingStatus = null;
      });
    },

    saveFollowedProduct() {
      const formData = new FormData()
      formData.append("product_id", this.productId)

      const config = {
        url: `/luettelointi/omalista`,
        method: 'post',
        data: formData,
      }

      this.sendQuery(config)
    },

    deleteFollowedProduct() {
      const config = {
        url: `/luettelointi/omalista/${this.followedProductId}`,
        method: 'delete',
      }

      this.sendQuery(config)
    },

    sendQuery(config) {
      this.loadingStatus = "loading"
      
      axios(config)
      .then((response) => {
        //console.log(response)

        if (response.data.error) {
          console.log(response.data.error)
          this.loadingStatus = "error"
        } else {
          this.loadingStatus = "success"
        }

        setTimeout(() => {
          this.loadingStatus = null
        }, 1000)
      })
      .catch((error) => {
        console.log(error)

        this.loadingStatus = "error"

        setTimeout(() => {
          this.loadingStatus = null
        }, 1000)
      })
      .finally(() => {
        // Get followed product again using event bus
        EventBus.$emit('refresh-followed-product');
      });

    },


  },

}
</script>

<style scoped>

</style>
